import { ProductVariant } from '@/models/ProductVariant';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Image, ImageAction } from '@/components/ImageCollection/ImageCollection';
import { Options } from '@/components/mi-dialog/MiDialog';
import ErrorHandler from '@/support/ErrorHandler';
import { Product, ProductIncludes } from '@/models/Product';

@Component<ProductImages>({})
export default class ProductImages extends Vue {
  //#region @Props
  /**
  * ie.
  * @Prop()
  * protected user!: User
  */

  @Prop()
  protected product!: ProductVariant;
  //#endregion


  //#region @Refs
  /**
  * ie.
  * @Ref()
  * readonly anotherComponent!: AnotherComponent
  */
  //#endregion


  //#region Class properties
  /**
  * ie.
  * protected isLoading = true;
  * * protected company: Company | null = null;
  */

  protected isLoading = false;
  protected selectedImage: Image | null = null;
  //#endregion


  //#region Lifecycle Hooks / Init
  /**
  * ie.
  * protected mounted(): void {
  *  console.log('MyComponent has Mounted');
  * }
  */
  //#endregion


  //#region Class methods
  /**
  * ie.
  * protected toggleLoading(): void {
  *  this.isLoading = ! this.isLoading;
  * }
  */
  //#endregion


  //#region Async methods
  /**
  * ie.
  * protected async fetchUserCompany(): Promise<void> {
  *  this.company = await new Company().filter({user: this.user.id}).all();
  * }
  */
  //#endregion


  //#region Getters & Setters
  /**
  * ie.
  * protected get companyName(): string {
  *  return this?.company.name || 'N/A';
  * }
  */

  protected get imageActions(): ImageAction[] {
    return [
      {
        click: (image) => {
          if (!image) {
            return;
          }
          this.selectedImage = image;
          this.$store.dispatch('openDialog', this.dialogOptionsSetDefaultImage);
        },
        icon: 'photo_album',
        class: (image) => {
          return image && (this.product.image_url === image.url_medium) ? 'default' : '';
        },
        hidden: (image) => {
          return image && (this.product.image_url === image.url_medium) || false;
        }
      },
      {
        click: (image) => {
          if (!image) {
            return;
          }
          window.open(image.url_large, '_blank');
        },
        icon: 'remove_red_eye',
      },
      {
        click: (image) => {
          if (!image) {
            return;
          }
          this.selectedImage = image;
          this.$store.dispatch('openDialog', this.dialogOptionsDeleteImage);
        },
        icon: 'delete',
        class: 'delete',
      },
    ]
  }

  get dialogOptionsDeleteImage(): Options {
    return {
      title:
      this.selectedImage ? this.selectedImage.name :
        this.$t('dialogOptions.confirmation').toString(),
      text: this.$tc('dialogOptions.delete', 2, {
        item: this.$tc('image.title', 1)
      })
        .toString()
        .toLowerCase(),
      type: 'warning',
      buttons: {
        confirm: {
          text: this.$t('dialogOptions.button.delete').toString(),
          action: async () => {
            if (
              !this.product ||
              !this.product.id ||
              !this.selectedImage ||
              !this.selectedImage.id
            ) {
              return;
            }

            const payload = {
              image: this.selectedImage.id,
              image_origin: this.selectedImage.origin
            };

            try {
              const product: Product = await new Product()
                .include([
                  ProductIncludes.BRAND,
                  ProductIncludes.IMAGES,
                  ProductIncludes.CATEGORIES,
                  ProductIncludes.SUPPLIER,
                ])
                .detachImage(this.product.id, payload)

              this.$emit('update:product', product);
            } catch (error) {
              ErrorHandler.network(error);
            }
          }
        },
        cancel: {
          text: this.$t('dialogOptions.button.cancel').toString(),
          action: () => {
            this.selectedImage = null;
          }
        }
      }
    };
  }

  get dialogOptionsSetDefaultImage(): Options {
    return {
      title:
      this.selectedImage ? this.selectedImage.name :
        this.$t('dialogOptions.confirmation').toString(),
      text: 'Weet je zeker dat je deze foto als default wilt hebben?',
      type: 'warning',
      buttons: {
        confirm: {
          text: this.$t('dialogOptions.button.ok').toString(),
          action: async () => {
            if (
              !this.product ||
              !this.product.id ||
              !this.selectedImage ||
              !this.selectedImage.id
            ) {
              return;
            }

            const payload = {
              image: this.selectedImage.id,
              image_origin: this.selectedImage.origin
            };

            try {
              const product: Product = await new Product()
                .include([
                  ProductIncludes.BRAND,
                  ProductIncludes.IMAGES,
                  ProductIncludes.CATEGORIES,
                  ProductIncludes.SUPPLIER,
                ])
                .setDefaultImage(this.product.id, payload)

              this.$emit('update:product', product);
              this.$emit('initialize');
            } catch (error) {
              ErrorHandler.network(error);
            }
          }
        },
        cancel: {
          text: this.$t('dialogOptions.button.cancel').toString(),
          action: () => {
            this.selectedImage = null;
          }
        }
      }
    };
  }
  //#endregion


  //#region @Watchers
  /**
  * ie.
  * @Watch('company')
  * protected companyChanged() {
  *  console.log('Company Changed') ;
  * }
  */
  //#endregion
}
